/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface FormateurHoraireIncoherenceSearch
 */
export interface FormateurHoraireIncoherenceSearch {
    /**
     * 
     * @type {number}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    idformateur?: number | null;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    idtypeIncoherence?: Int32ListSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    centreUtilisateurFlag?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurHoraireIncoherenceSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurHoraireIncoherenceSearch interface.
 */
export function instanceOfFormateurHoraireIncoherenceSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurHoraireIncoherenceSearchFromJSON(json: any): FormateurHoraireIncoherenceSearch {
    return FormateurHoraireIncoherenceSearchFromJSONTyped(json, false);
}

export function FormateurHoraireIncoherenceSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurHoraireIncoherenceSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'idtypeIncoherence': !exists(json, 'idtypeIncoherence') ? undefined : Int32ListSearchFromJSON(json['idtypeIncoherence']),
        'centreUtilisateurFlag': !exists(json, 'centreUtilisateurFlag') ? undefined : BooleanSearchFromJSON(json['centreUtilisateurFlag']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurHoraireIncoherenceSearchToJSON(value?: FormateurHoraireIncoherenceSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idformateur': value.idformateur,
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'idtypeIncoherence': Int32ListSearchToJSON(value.idtypeIncoherence),
        'centreUtilisateurFlag': BooleanSearchToJSON(value.centreUtilisateurFlag),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

